import { render, staticRenderFns } from "./presDiferencia.vue?vue&type=template&id=3f681f98"
import script from "./presDiferencia.vue?vue&type=script&lang=js"
export * from "./presDiferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports